import { Action } from "@ngrx/store";
import { type } from "../../util";
import { Plan } from "@core/store/plan/plan.model";

/**
 * Action Types
 */
export const ActionTypes = {
  LOAD: type("[PlanEditor] Load"),
  LOAD_SUCCESS: type("[PlanEditor] Load Success"),
  LOAD_FAIL: type("[PlanEditor] Load Fail"),
  CHANGE_STEP: type("[PlanEditor] Change Step"),
  CHANGE_NAME: type("[PlanEditor] Change Name"),
  CHANGE_NAME_SUCCESS: type("[PlanEditor] Change Name Success"),
};

/**
 * Actions
 */
export class LoadPlanAction implements Action {
  type = ActionTypes.LOAD;
  constructor(public payload: any) {}
}

export class LoadPlanSuccessAction implements Action {
  type = ActionTypes.LOAD_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadPlanFailAction implements Action {
  type = ActionTypes.LOAD_FAIL;
  constructor(public payload?: any) {}
}

export class ChangeStepAction implements Action {
  type = ActionTypes.CHANGE_STEP;
  constructor(public payload: string) {}
}

export class ChangeNameAction implements Action {
  type = ActionTypes.CHANGE_NAME;
  constructor(public payload: string) {}
}

export class ChangeNameSuccessAction implements Action {
  type = ActionTypes.CHANGE_NAME_SUCCESS;
  constructor(public payload: Plan) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Action =
  | LoadPlanAction
  | LoadPlanSuccessAction
  | LoadPlanFailAction
  | ChangeStepAction
  | ChangeNameAction
  | ChangeNameSuccessAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan-editor.actions.ts